/**
 * Imperative sign-in prompt for guests who try to like, save, comment, or follow.
 * SignInPrompt registers the handler from inside the router.
 */

let handler = null;

export function registerSignInPrompt(fn) {
  handler = typeof fn === "function" ? fn : null;
}

/**
 * @param {{ reason: string, redirect?: string }} options
 */
export function requestSignIn(options) {
  const reason = options?.reason || "Sign in to continue.";
  const redirect = options?.redirect;
  if (handler) {
    handler({ reason, redirect });
  }
}
